import type { AgentRunSummary } from '../model'

/** The classification session plus the matching session, when either has a cost. */
export function getRunTotalCost(
  run: Pick<AgentRunSummary, 'cost_usd' | 'match_cost_usd'>,
): number | null {
  if (typeof run.cost_usd !== 'number' && typeof run.match_cost_usd !== 'number') return null
  return (run.cost_usd ?? 0) + (run.match_cost_usd ?? 0)
}
